import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import HotelBanner from '../Components/Hotel/HotelBanner';
import HotelListings from '../Components/Hotel/HotelListings';
import HotelServices from '../Components/Hotel/HotelServices';
import FooterOne from '../Components/Footer/FooterOne';
import ScrollToTop from '../Components/ScrollToTop';

function HomeBnb() {
    return (
        <div>
            <HeaderOne />
            <HotelBanner />
            <HotelListings />
            <HotelServices />
            <FooterOne />
            <ScrollToTop />
        </div>
    );
}

export default HomeBnb;
